import { call, race, take, put } from 'redux-saga/effects'
import { CANCEL_ALL_CONVERSATIONS } from '../../modules/actions/tools'

export function* handleWebSocketRequest({ service, serviceProps, cancelActionType, successAction, failureAction }) {
  let socket = null
  const onSocketOpen = openedSocket => {
    socket = openedSocket
  }

  try {
    const { response, cancel } = yield race({
      response: call(service, { ...serviceProps, onSocketOpen }),
      // avoid loading, if items were cleared
      cancel: take(
        action =>
          action.type === CANCEL_ALL_CONVERSATIONS ||
          (action.type === cancelActionType && action.requestId === serviceProps.requestId)
      )
    })

    if (cancel) {
      // close the websocket connection if it was cancelled
      socket.close()
    } else if (response) {
      yield put(successAction(response))
    }
  } catch (error) {
    yield put(failureAction(error))
  }
}
